import * as React from 'react'
import { observer } from 'mobx-react'
import { action } from 'mobx'
import LocalizationStore from '../../../Stores/LocalizationStore'
import HttpActionsService from '../../../Services/HttpActionsService'
import UserStore from '../../../Stores/UserStore'
import ConfigStore from '../../../Stores/ConfigStore'
import { history } from '../../../Routing'
import LanguageSelectorView from '../LanguageSelector/view'
import { Link } from 'react-router-dom'

interface IUserInfoProps {
}

@observer
export default class UserInfoView extends React.Component<IUserInfoProps> {

    constructor(props: IUserInfoProps) {
        super(props)
    }

    config = ConfigStore.getInstance()
    userStore = UserStore.getInstance()
    user = UserStore.getInstance()
    ls = LocalizationStore.getInstance()

    @action.bound
    setLanguage(key: 'RU' | 'EN' | 'AZ') {
        LocalizationStore.getInstance().setLanguage(key)
    }

    languageBar() {
        if (this.config.showLangs) {
            return (
                <span className="nav langs" hidden={!this.config.showLangs}>
                    <LanguageSelectorView setLanguage={this.setLanguage!} />
                </span>
            )
        }
        return ''
    }

    logout(e: any) {
        e.preventDefault()
        this.userStore.killSession()
        history.push('/login')
    }

    login(e: any) {
        e.preventDefault()
        history.push('/login')
    }

    handleActiveSwitchChange(el: any) {
        HttpActionsService.getInstance().toggleIsActiveUser(this.user.id)
    }

    render() {
        const ls = LocalizationStore.getInstance()

        this.user = UserStore.getInstance()

        return (
            <div className="user-info">
                {this.languageBar()}
                <div className="userIconwithInfo">
                    <Link to={'/user/' + this.user.id} className="user-photo">
                        <img src="images/user-icon.svg" />
                    </Link>
                    <div className="user-info-part">
                        <div>
                            <Link to={'/user/' + this.user.id}>
                                <span className="header-user-name ellipsis">{this.user.name}</span>
                            </Link>
                            <div>
                                <span
                                    className="header-user-role roles ellipsis"
                                    title={this.userStore && this.userStore.translatedRoles 
                                        ? this.userStore.translatedRoles 
                                        : ''}
                                >
                                    {this.user && this.userStore.translatedRoles 
                                        ? this.userStore.translatedRoles 
                                        : ''}&nbsp;
                                </span>
                                <span>
                                    <a
                                        className="header-logout ellipsis"
                                        href="#"
                                        onClick={(e) => { return this.logout(e) }}
                                    >
                                        {ls.t!('LogoutBtn')}
                                    </a>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Account/UserInfoView.tsx